export var WLBType;
(function (WLBType) {
    // Do not change this enum, please
    WLBType[WLBType["BARGE"] = 1] = "BARGE";
    WLBType[WLBType["WHISPER"] = 2] = "WHISPER";
    WLBType[WLBType["SPY"] = 3] = "SPY";
})(WLBType || (WLBType = {}));
//# sourceMappingURL=types.js.map